import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Row, Col, message } from 'antd';
import { WarehouseWithStats } from '../../store/api/warehousesApi';
import AddressAutocomplete from '../common/AddressAutocomplete';

interface WarehouseDetailsModalProps {
  visible: boolean;
  warehouse: WarehouseWithStats | null;
  onClose: () => void;
  onSave: (data: Partial<WarehouseWithStats>) => Promise<void>;
}

const WarehouseDetailsModal: React.FC<WarehouseDetailsModalProps> = ({
  visible,
  warehouse,
  onClose,
  onSave
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (warehouse) {
      form.setFieldsValue({
        name: warehouse.name,
        city: warehouse.city,
        address: warehouse.address,
        contactPerson: warehouse.contactPerson,
        phone: warehouse.phone
      });
    } else {
      form.resetFields();
    }
  }, [warehouse, form]);

  const handleFinish = async (values: any) => {
    if (!warehouse) return;
    try {
      await onSave({ ...warehouse, ...values });
      message.success('Склад успешно обновлен');
    } catch (e) {
      message.error('Ошибка при сохранении');
    }
  };

  return (
    <Modal
      title={warehouse ? 'Редактировать склад' : 'Создать склад'}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      destroyOnHidden
    >
      {warehouse && (
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="name" label="Название склада" rules={[{ required: true, message: 'Введите название' }]}> <Input /> </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="city" label="Город" rules={[{ required: true, message: 'Введите город' }]}> <Input /> </Form.Item>
            </Col>
          </Row>
          <Form.Item name="address" label="Адрес">
            <AddressAutocomplete placeholder="Полный адрес склада" style={{ width: '100%' }} />
          </Form.Item>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="contactPerson" label="Контактное лицо"> <Input /> </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="phone" label="Телефон"> <Input /> </Form.Item>
            </Col>
          </Row>
          <div style={{ marginBottom: 16 }}>
            <b>Грузов на складе:</b> {warehouse._count?.cargoOnWarehouse ?? 0}
          </div>
          <div style={{ textAlign: 'right' }}>
            <Button onClick={onClose} style={{ marginRight: 8 }}>Отмена</Button>
            <Button type="primary" htmlType="submit">Сохранить</Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default WarehouseDetailsModal; 